<!-- 课程管理 添加 -->
<template>
  <div class="quicklocation">
    <button class="toggle-btn" @click="toggleAddressList">
      {{ isExpanded ? '收起常用地址' : '展开选择常用地址' }}
      <span class="arrow">{{ isExpanded ? '▲' : '▼' }}</span>
    </button>

    <div class="address-wrapper" :class="{ 'is-expanded': isExpanded }">
      <div class="_address">
        <div v-for="(item,index) in options" :key="index + item.address" class="_items">
          <p class="text-content font-grey" @click="onClickItem(item)">{{ item.address }}</p>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { selectRelateAddressApi } from "@/api/module/schedulingaddress";


export default {
  name: "quicklocation",
  data() {
    return {
      options: [],
      isExpanded: false // Stat

    };
  },
  methods:{
    init(){
      selectRelateAddressApi()
        .then((datas)=>{
          this.options = datas;
        })
    },

    toggleAddressList() {
      this.isExpanded = !this.isExpanded;
    },


    emitDatas() {

      // QMarker
      console.log("emitDatas",QMarker)

      // 更新 lng / lat
      let addressData = {
        lat: this.lat,
        lng: this.lng,
        location: this.location,
      };
      this.$emit("onAddressChanged", addressData,this.index);

    },

    onClickItem(item){
      console.log("onClickItem",item)

      let data = {
        lat: item.lat,
        lng: item.lng,
        address: item.address,
        gpsoffsetlevel: item.gpsoffsetlevel
      }

      this.$emit("onChoose", data);

      this.$message.success("已选择地址: " + item.address);
    }



  },

  watch:{

  },

  created() {

  },

  mounted() {
    this.init();
  },
};








// @ is an alias to /src
// declare var BMapGL: any;

</script>

<style scoped lang="scss">
.quicklocation {

    // height: 300px;
    display: flex;
    flex-direction: column;

    .toggle-btn {
      background-color: #3d9b54;
      color: white;
      border: none;
      padding: 8px 15px;
      border-radius: 4px;
      cursor: pointer;
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%; // Or auto depending on design
      max-width: 600px; // Match the width of items below
      margin-bottom: 5px;
      transition: background-color 0.3s;

      &:hover {
        background-color: #2b6d3b;
      }

      .arrow {
        margin-left: 10px;
        font-size: 12px;
      }
    }

    ._items{
      width: 100%; /* Full width of the container */
      width: 600px; /* Optional: limit max width */
      margin: 5px 0;
      padding: 5px 0; /* Added some padding for clickability/spacing */
      cursor: pointer; 

      p{
        margin: 0;
        padding: 0px;
        white-space: nowrap; /* Prevents text wrapping if desired */
        overflow: hidden;
        text-overflow: ellipsis;
      }

      &:hover {
          background-color: #f5f7fa; /* Optional: hover effect */
      }
    }

    .address-wrapper {
      max-height: 0;
      opacity: 0;
      overflow: hidden;
      transition: max-height 0.3s ease-in-out, opacity 0.3s ease-in-out;
      width: 100%;
      max-width: 600px;
    }

    .address-wrapper.is-expanded {
      max-height: 300px; /* Should match the height of ._address */
      opacity: 1;
    }
    
    ._address {
      // Fixed height for the scrollable area when expanded
      padding: 0 10px;
      height: 300px; 
      overflow-y: auto; /* Enables vertical scrolling */
      overflow-x: hidden; /* Prevents horizontal scrolling */
      display: flex;
      flex-direction: column;
      border: 1px solid #ebeef5; // Optional: add border for visual separation
      border-radius: 4px;
      background-color: #ffffffc9;
    }


  
}

</style>

